import { render, staticRenderFns } from "./AnimalScroller.vue?vue&type=template&id=39463fa4&scoped=true"
import script from "./AnimalScroller.vue?vue&type=script&lang=js"
export * from "./AnimalScroller.vue?vue&type=script&lang=js"
import style0 from "./AnimalScroller.vue?vue&type=style&index=0&id=39463fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39463fa4",
  null
  
)

export default component.exports